import * as TypesResource from '../types/types_resource';
import Vue from 'vue';

export default {
    state: {},
    mutations: {},
    actions: {
    // 获取资源库列表
        [TypesResource.RESOURCE_GET_LIST](ctx, { type, isFavorite, searchContent, start, limit }) {
            // return resourceList;
            return Vue.http.get('/v1/resources/list', {
                params: {
                    type, isFavorite, searchContent, start, limit
                }
            }).then(resp => {
                return Vue.checkResp(resp, {});
            }).then(data => {
                return data;
            });
        },
        // 修改资源库资源收藏状态
        [TypesResource.RESOURCE_MODIFY_COLLECTION](ctx, { id, isFavorite }) {
            return Vue.http.put(`/v1/resources/${id}/favorite-status`, { isFavorite }).then(resp => {
                return Vue.checkResp(resp, {});
            }).then(data => {
                return data;
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_resource.js